// HCC Admissions - Mock Data

export const BRAND = {
  name: 'HCC Admissions',
  full: 'Heritage Community College',
  tagline: 'Admissions Portal',
  logo: 'https://customer-assets.emergentagent.com/job_ef63da9f-9338-4fb9-ac68-2fc6fbb70315/artifacts/xwad0ar7_Asset%202.png',
  email: 'info@hccbcadmissions.com',
  phone: '+1 (604) 593-5400',
};

export const COUNTRY_CODES = [
  { code: '+1', label: 'US/CA +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+91', label: 'IN +91' },
  { code: '+86', label: 'CN +86' },
  { code: '+234', label: 'NG +234' },
  { code: '+63', label: 'PH +63' },
  { code: '+92', label: 'PK +92' },
  { code: '+880', label: 'BD +880' },
  { code: '+977', label: 'NP +977' },
  { code: '+94', label: 'LK +94' },
  { code: '+971', label: 'AE +971' },
  { code: '+966', label: 'SA +966' },
  { code: '+82', label: 'KR +82' },
  { code: '+81', label: 'JP +81' },
  { code: '+49', label: 'DE +49' },
  { code: '+33', label: 'FR +33' },
  { code: '+61', label: 'AU +61' },
  { code: '+55', label: 'BR +55' },
  { code: '+52', label: 'MX +52' },
  { code: '+27', label: 'ZA +27' },
  { code: '+254', label: 'KE +254' },
  { code: '+233', label: 'GH +233' },
  { code: '+20', label: 'EG +20' },
  { code: '+60', label: 'MY +60' },
  { code: '+65', label: 'SG +65' },
  { code: '+353', label: 'IE +353' },
  { code: '+64', label: 'NZ +64' },
];

export const STATUS_OPTIONS = [
  'Study Permit',
  'Work Permit',
  'Visitor',
  'Permanent Resident',
  'Canadian Citizen',
  'Refugee / Protected Person',
  'Other',
];
